import { render, staticRenderFns } from "./EntCertify.vue?vue&type=template&id=a38394c6&scoped=true"
import script from "./EntCertify.vue?vue&type=script&lang=js"
export * from "./EntCertify.vue?vue&type=script&lang=js"
import style0 from "./EntCertify.vue?vue&type=style&index=0&id=a38394c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38394c6",
  null
  
)

export default component.exports